"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var createStore_1 = require("./createStore");

var utils_1 = require("./utils");

var createProvider_1 = require("./createProvider");

var connect_1 = require("./connect");

function createUniqueStore(reducer, enhancer, namespace) {
  var store = createStore_1.default(reducer, enhancer);
  var storeKey = utils_1.uuid(namespace);

  function uniqueConnect(mapStateToProps, actions, mergedProps, options) {
    if (mapStateToProps === void 0) {
      mapStateToProps = null;
    }

    if (actions === void 0) {
      actions = null;
    }

    if (mergedProps === void 0) {
      mergedProps = {};
    }

    if (options === void 0) {
      options = {};
    }

    return connect_1.default(mapStateToProps, actions, mergedProps, __assign({}, options, {
      store: store
    }));
  }

  return {
    store: store,
    Provider: createProvider_1.default({
      storeKey: storeKey
    }),
    connect: uniqueConnect
  };
}

exports.default = createUniqueStore;